import { createRoot } from 'react-dom/client'
import SearchPageInit from './components/SearchPageInit'

const container = document.getElementById('ss-search-page-init')!
const root = createRoot(container)
root.render(
    <SearchPageInit />
)
